import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { CommonMessageService } from 'src/app/services/common-message.service';
import { OrganizationSetupService } from 'src/app/services/organization-setup.service';

@Component({
  selector: 'app-manage-announcement-history',
  templateUrl: './manage-announcement-history.component.html',
  styleUrls: ['./manage-announcement-history.component.css']
})
export class ManageAnnouncementHistoryComponent implements OnInit {
  fromDate;
  convertFromDate;
  toDate;
  announcementHistoryList=[];
  constructor(private organizationSetupService:OrganizationSetupService,private commonMessageService:CommonMessageService) { }

  ngOnInit(): void {
  }

  onFromDateChange(fromDate) {
    this.convertFromDate=fromDate;

    var formatFromDate = new Date(fromDate.year+'-'+fromDate.month+'-'+fromDate.day);
    this.fromDate=moment(formatFromDate).format('YYYY-MM-DD');

     console.log('this.convertFromDate',this.convertFromDate);
   }
 
   onToDateChange(toDate) {
     var FormatToDate=new Date(toDate.year+'-'+toDate.month+'-'+toDate.day);
     this.toDate=moment(FormatToDate).format('YYYY-MM-DD');
     console.log('toDate',this.toDate);
   }

  onClickViewDetails(){
    console.log('formdate to date', this.fromDate , this.toDate);
    if(this.fromDate ==undefined || this.toDate == undefined ){
    this.commonMessageService.swalAlertWithoutIcon('','Please select all fields');
    }else{
    this.organizationSetupService.getAnnouncementHistory(this.fromDate,this.toDate).subscribe((res:any)=>{
     console.log('history res',res);
     this.announcementHistoryList=res;
    })
  }
  }
}
